import React from 'react';
import { useSelector } from 'react-redux';
import { getExpandedMode, getTagsComposition, getLoading } from '../selectors';
import '../styles.scss';
import { TagsLine } from './TagsLine';
import { TagItem } from './TagItem';
import { TagsExpanded } from './TagsExpanded';
import { TagsSkeleton } from '../../skeleton/components/Skeleton';

export const Tags = () => {
  const items = useSelector(getTagsComposition);
  const expandedMode = useSelector(getExpandedMode);
  const loading = useSelector(getLoading);

  const tagList = items.map(({ tag, selected }) => (
    <TagItem key={tag.id} tag={tag} selected={selected} />
  ));

  // Сначала в списке идут выбранные теги, затем связанные, затем обычные.
  // Добавляем разделитель между связанными и обычными тегами.
  // Для этого находим первый обычный тег и вставляем разделитель перед ним.
  // Если же обычный тэг идет первым в списке или обычных тегов вообще нет, то разделитель не нужен.
  const index = items.findIndex(({ selected, related }) => !selected && !related);
  if (index > 0) {
    const divider = <div key="divider" className="al-tags-divider" />;
    tagList.splice(index, 0, divider);
  }

  // Скелетон только когда показывать нечего. Теги перезапрашиваются почти на каждое
  // действие с фильтрами, и спиннер поверх уже показанной строки здесь мигал чаще всего.
  if (loading && items.length === 0) {
    return (
      <div className="al-tags" aria-busy>
        <TagsSkeleton />
      </div>
    );
  }

  return (
    <div className="al-tags">
      {expandedMode ? <TagsExpanded content={tagList} /> : <TagsLine content={tagList} />}
    </div>
  );
};
